import { render, staticRenderFns } from "./REMGlevel.vue?vue&type=template&id=fa6c0794&scoped=true&"
import script from "./REMGlevel.vue?vue&type=script&lang=js&"
export * from "./REMGlevel.vue?vue&type=script&lang=js&"
import style0 from "./REMGlevel.vue?vue&type=style&index=0&id=fa6c0794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6c0794",
  null
  
)

export default component.exports